import { useEffect, useState } from 'react'

// Rotates through 0..count-1 on a fixed interval, pinned to the first item
// whenever motion is off. The Sketch prototype's own brand-stack carousel
// (live-updates-onboarding v31) is a plain setInterval over its cards.
export function useCyclingIndex(
  count: number,
  animated: boolean,
  intervalMs: number
): number {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (!animated || count < 2) {
      setIndex(0)
      return
    }
    const timer = setInterval(
      () => setIndex(prev => (prev + 1) % count),
      intervalMs
    )
    return () => clearInterval(timer)
  }, [animated, count, intervalMs])

  return index
}
